import { IBaseResource, Page } from "../api.types";
import { IUserMinimal } from "../users";

export const MAX_CORE_SKILLS = 8;

export interface ISkillFile {
    id: number;
    skill_id: number;
    name: string;
    content: string;
    created_at: string;
    updated_at: string;
}

export interface ISkillFileCreate {
    name: string;
    content: string;
}

export interface ISkillFileUpdate {
    name?: string;
    content?: string;
}

export interface ISkillVersion {
    id: number;
    version_number: number;
    published_by: number;
    publisher: IUserMinimal;
    published_at: string;
}

export interface ISkillBase {
    name?: string;
    description?: string;
    content?: string;
    is_core?: boolean;
}

export interface ISkillCreate extends ISkillBase {
    name: string;
    description: string;
    content: string;
    files?: ISkillFileCreate[];
    organization_id?: number | null;
    organization_group_id?: number | null;
}

export interface ISkillUpdate extends ISkillBase {
    organization_id?: number | null;
    organization_group_id?: number | null;
}

export interface ISkillDuplicate {
    name: string;
    organization_id: number | null;
}

export interface ISkill extends IBaseResource {
    name: string;
    slug: string;
    description: string;
    content: string;
    claude_skill_id?: string;
    published_at?: string;
    organization_id: number | null;
    organization: { id: number; name: string } | null;
    organization_group_id?: number | null;
    organization_group?: { id: number; name: string } | null;
    skill_files: ISkillFile[];
    status: "active" | "inactive";
    is_core: boolean;
    /** Max skill name length for this environment (set by the API). */
    name_max_length: number;
}

export interface ISkillFileSnapshot {
    name: string;
    content: string;
}

export interface ISkillSnapshot {
    name: string;
    slug: string;
    description: string;
    content: string;
    files: ISkillFileSnapshot[];
}

export interface ISkillVersionDetail {
    id: number;
    version_number: number;
    snapshot: ISkillSnapshot;
    published_by: number;
    publisher: IUserMinimal;
    published_at: string;
}

export interface ISkillMinimal {
    id: number;
    name: string;
    slug: string;
}

export type IPaginatedSkills = Page<ISkill>;

/**
 * Matches backend `count_core` semantics: LIVE core skills are published +
 * synced to Anthropic. Drafts and unsynced skills are NOT in `coreCount`.
 */
export function isLiveCoreSkill(skill: ISkill): boolean {
    return !!skill.is_core && !!skill.claude_skill_id && !!skill.published_at;
}

export interface ISkillListParams {
    page: number;
    pageSize?: number;
    sortBy?: string;
    order?: "asc" | "desc";
    organizationId?: number | null;
    search?: string;
}
